import { createUseStyles } from 'react-jss'
import { lightGrey } from '../../../../../../../styles/const/colors'

const useStyles = createUseStyles({
  inventoryListHeader: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: 46, // align with all inventory item content
    borderBottom: `1px solid ${lightGrey}`,
    paddingBottom: 16,
    marginTop: 20
  }
})

export default useStyles
